import html5 from './images/frameworks/html5.png';
import css3 from './images/frameworks/css3.png';
import javascript from './images/frameworks/javascript.png';
import reactjs from './images/frameworks/reactjs.png';
import nodejs from './images/frameworks/nodejs.png';
import expressjs from './images/frameworks/expressjs.png';
import firebase from './images/frameworks/firebase.png';
import mongodb from './images/frameworks/mongodb.png';
import github from './images/frameworks/github.png';
import vscode from './images/frameworks/vscode.png';
import notion from './images/frameworks/notion.png';
import trello from './images/frameworks/trello.png';
import figma from './images/frameworks/figma.png';
import msoffice from './images/frameworks/msoffice.png';

export const utilities = [
  {
    title: 'Github Desktop',
    image: github,
  },
  {
    title: 'VSCode',
    image: vscode,
  },
  {
    title: 'Notion',
    image: notion,
  },
  {
    title: 'Trello',
    image: trello,
  },
  {
    title: 'Figma',
    image: figma,
  },
  {
    title: 'MSOffice',
    image: msoffice,
  },
];

export const frontEnd = [
  {
    title: 'HTML5',
    image: html5,
  },
  {
    title: 'CSS3',
    image: css3,
  },
  {
    title: 'JavaScript',
    image: javascript,
  },
  {
    title: 'React & React Native',
    image: reactjs,
  },
];

export const backEnd = [
  {
    title: 'NodeJS',
    image: nodejs,
  },
  {
    title: 'MongoDB',
    image: mongodb,
  },
  {
    title: 'ExpressJS',
    image: expressjs,
  },
  {
    title: 'Firebase',
    image: firebase,
  },
];
